const mobMenu = {
  nextLevel: document.querySelectorAll(
    '.jsNextLevel',
  ) as NodeListOf<HTMLElement>,
  prevLevel: document.querySelectorAll(
    '.jsPrevLevel',
  ) as NodeListOf<HTMLElement>,
  close: document.getElementById('jsCloseMenu') as HTMLElement,
  popup: document.getElementById('jsMenuWrap') as HTMLElement,
  userBtn: document.getElementById('jsOpenUser') as HTMLElement,

  init() {
    this.setNextLevel();
    this.setPrevLevel();
  },




  setNextLevel() {
    this.nextLevel.forEach((item) => {
      const subMenu = item.nextElementSibling as HTMLElement;
      if (subMenu) {
        item.addEventListener('click', (e) => {
          e.preventDefault();
          subMenu.classList.add('activeClass');

          if(item.innerText === 'My Account') {
            this.popup.classList.add('popup--user');
          }
        });
      }

      this.close.addEventListener('click', () => {
        subMenu.classList.remove('activeClass');
      });
    });
  },

  setPrevLevel() {
    this.prevLevel.forEach((item) => {
      const menu = item.parentElement?.parentElement as HTMLElement;
      if (menu) {
        item.addEventListener('click', () => {
          menu?.classList.remove('activeClass');

          if(item.innerText === 'Back') {
            this.popup.classList.remove('popup--user');
          }
        });
      }
      this.close.addEventListener('click', () => {
        menu?.classList.remove('activeClass');
        this.popup.classList.remove('popup--user');
      });
    });
  },
};

export default mobMenu;
